import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated, MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "../authConfig";

const AuthContext = React.createContext();

export const useAuthProvider = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("site") || "");
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated && accounts.length > 0) {
      const account = accounts[0];
      console.log("User is authenticated with account:", account);
      setUser(account);
    }
  }, [isAuthenticated, accounts]);

  const msalInstance = new PublicClientApplication(msalConfig);

  useEffect(() => {
    if (
      !msalInstance.getActiveAccount() &&
      msalInstance.getAllAccounts().length > 0
    ) {
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    msalInstance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload.account
      ) {
        const account = event.payload.account;
        console.log("Login successful for account:", account);
        msalInstance.setActiveAccount(account);
        setUser(account);
        setToken(event.payload.accessToken);
        localStorage.setItem("site", event.payload.accessToken);
      }
    });
  }, [msalInstance]);

  const loginAction = async () => {
    try {
      if (!isAuthenticated) {
        const response = await instance.loginPopup();
        console.log("Login response:", response);
        setUser(response.account);
        setToken(response.accessToken);
        localStorage.setItem("site", response.accessToken);
        await fetchPortfolioData(response.account.username);
      } else {
        console.log(
          "Already authenticated. Fetching portfolio data for user:",
          accounts[0].username
        );
        await fetchPortfolioData(accounts[0].username);
      }
    } catch (error) {
      console.error("Login failed:", error);
      navigate("/error");
    }
  };

  const fetchPortfolioData = async (email) => {
    console.log("Fetching portfolio data for email:", email);
    try {
      const dataResponse = await fetch("/data", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const portfolioData = await dataResponse.json();
      console.log("Portfolio data received:", portfolioData);

      if (portfolioData.length === 1) {
        window.location.href = portfolioData[0].Url;
      } else {
        navigate("/portfolio");
      }
    } catch (error) {
      console.error("Failed to fetch portfolio data:", error);
      navigate("/error");
    }
  };

  return (
    <AuthContext.Provider value={{ user, loginAction, token }}>
      <MsalProvider instance={msalInstance}>{children}</MsalProvider>
    </AuthContext.Provider>
  );
};

export default AuthProvider;
